import { useDataSource } from '@/features/data/DataSourceContext';
import { useListReportsQuery } from './api/reports.api';

export function useReportNameResolver(): (reportId: string) => string | undefined {
  const { source } = useDataSource();
  const { data } = useListReportsQuery({ source, params: undefined });
  return (reportId) => data?.find((report) => report.id === reportId)?.name;
}
